import React, {Component} from 'react';
import {connector} from '../store';
import {getAdOptionsForCurrentPage} from '../helpers';
import Core from '../../Core/Core';

export class Sponsors extends Component {
  state: {
    googletagLoaded: boolean
  };

  constructor(props) {
    super(props);

    this.state = {
      googletagLoaded: false
    };
  }

  componentDidMount() {
    Core.googleAds.onload(this.enable.bind(this));
  }

  loadAd(ref) {
    Core.googleAds.whenInitialized().then( () => {
      Core.googleAds.displayAd(
        Core.googleAds.initializeAd(ref.id)
      );
    }, error => {
      console.error("Failed to load ads: " + error);
    })
    .catch( (error ) => { 
       console.error("Failed to load ads: " + error )
    });
  }

  enable() {
    this.setState({
      googletagLoaded: true,
    });
  }

  render() {
    // Hard-code sponsorship ad units
    let sponsorAdUnits = [1, 2, 3, 4, 5, 6].map(unitNumber => {
      return {
        unit: "TPT_SHOW_SPONSOR_" + unitNumber,
        width: 290,
        height: 90, 
        collapse: true,
        sizes: "[[[0,0], [200,90]]]"
    }});

    return <div className="sponsors full-row row">
      <div className="small-12 columns">
        <div className="sponsors-header section-header headline">
          Sponsors
        </div>
        <div className="sponsors-description body-large">
          Support for {this.props.show.title} is provided by:
        </div>
        <ul className="sponsors-list small-block-grid-1 large-block-grid-2 xlarge-block-grid-3">
          {sponsorAdUnits.map(function(sponsor, i) {
            return <li key={sponsor.unit} className="sponsor-item">
              <div id={'show-sponsor-' + i}
                   ref={this.loadAd}
                   className="google-tag"
                   data-unit={sponsor.unit}
                   data-width={sponsor.width}
                   data-height={sponsor.height}
                   data-collapse={sponsor.collapse}
                   data-size-mappings={sponsor.sizes} />
            </li>;
          }.bind(this))}
        </ul>
      </div>
    </div>;
  }
}

export default connector(Sponsors);